import React from 'react';

import { Collapse } from 'antd';
import _ from 'lodash';

import styled from 'styled-components';

import { saxonize } from '@libs/NwUtils';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import Money from '@components/Gui/Money';
import TransactionTitleLine from '@components/Transactions/TransactionTitleLine';

const { Panel } = Collapse;

const EventTransactionsWrapper = styled.div`
    div.project-transactions-header {
        border-bottom: ${(props) => props.theme.DefaultBorder};
        background-color: ${(props) => props.theme.LayoutBodyBackground};
        padding: 0.4rem;
        min-height: 2rem;
        margin-left: -1px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        font-size: ${(props) => props.theme.FontSizeSm};

        h3 {
            text-transform: uppercase;
            margin-bottom: 0.25rem;
            font-size: ${(props) => props.theme.FontSizeSm};
        }
    }
    div.project-transaction-content {
        //padding: .5rem;
        .ant-collapse-header {
            padding: 0.5rem;
            text-transform: uppercase;
            font-size: ${(props) => props.theme.FontSizeSm};
        }
        .ant-collapse-content-box {
            padding: 0.5rem !important;
        }

        .project-transactions-content-total,
        .project-transactions-model {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            //font-size: ${(props) => props.theme.FontSizeSm};
            p {
                margin-bottom: 0;
            }
        }
    }
    .project-transactions-total-amounts {
        font-size: 0.9rem;
        font-weight: bold;
        text-align: right;
        span {
            display: block;
        }

        .project-transactions-agencyfees-line {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            span:first-child {
                font-weight: normal;
                padding-right: 0.5rem;
            }
        }
    }
`;

const NonBookingEventTransactionsSummary = ({ modelID, event }) => {
    let hastransactions = true;
    let hasmodeltransactions = true;

    if (event.Transactions && event.Transactions.length === 0) {
        hastransactions = false;
    }
    if (event.Models && !event.Models.some((item) => item.Transactions && item.Transactions.length > 0)) {
        hastransactions = false;
    }
    if (modelID && event.Models && event.Models.length > 0) {
        const model = event.Models.find((item) => item.ModelID === modelID);
        if (!model || model.Transactions.length === 0) {
            hasmodeltransactions = false;
        }
    } else {
        hasmodeltransactions = false;
    }

    const getTransactionsByCurrency = (transactions) => {
        if (transactions && transactions.length === 0) return null;
        return _.groupBy(transactions, 'Currency');
    };

    const EventTransactionsExternalJob = () => {
        if (!hastransactions) {
            return <div className="project-transactions-total-amounts">0</div>;
        }
        const transactionsByCurrency = getTransactionsByCurrency(event.Transactions);
        return (
            <div className="project-transactions-total-amounts">
                {Object.entries(transactionsByCurrency).map(([key, value]) => (
                    <Money key={key} highlightCurrency amounts={value.map((item) => item.TotalFee)} currency={key} />
                ))}
            </div>
        );
    };

    const EventTransactionsExternalJobDetails = () => {
        //TODO: usare totali da statement cliente per avere anche agencyfee
        if (!event.Transactions) return null;
        return event.Transactions.map((item) => (
            <div className="project-transactions-model">
                <TransactionTitleLine transaction={item} inline />
                <div className="project-transactions-total-amounts">
                    <Money highlightCurrency amount={item.TotalFee} currency={item.Currency} />
                </div>
            </div>
        ));
    };

    const EventTransactionsTotalAmount = () => {
        if (!hastransactions) {
            return <div className="project-transactions-total-amounts">0</div>;
        }
        const transactions = [];
        for (const m of event.Models) {
            if (m.Transactions && m.Transactions.length > 0) {
                for (const t of m.Transactions) {
                    transactions.push(t);
                }
            }
        }
        if (transactions.length === 0) return null;
        return (
            <div className="project-transactions-total-amounts">
                {Object.entries(getTransactionsByCurrency(transactions)).map(([key, value]) => (
                    <Money key={key} highlightCurrency amounts={value.map((item) => item.TotalFee)} currency={key} />
                ))}
            </div>
        );
    };

    const EventTransactionsByModel = () => {
        //TODO: usare totali da statement cliente per avere anche agencyfee
        return event.Models.map((model, index) => {
            if (model.Transactions && model.Transactions.length > 0) {
                return (
                    <div key={index} className="project-transactions-model">
                        <p>{getContactName(model.ModelID)}</p>
                        <div className="project-transactions-total-amounts">
                            {Object.entries(getTransactionsByCurrency(model.Transactions)).map(([key, value]) => (
                                <Money
                                    key={key}
                                    highlightCurrency
                                    amounts={value.map((item) => item.TotalFee)}
                                    currency={key}
                                />
                            ))}
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        });
    };

    const EventTransactionsModel = () => {
        if (!hasmodeltransactions) {
            return <div className="project-transactions-total-amounts">0</div>;
        }
        const model = event.Models.find((item) => item.ModelID === modelID);
        if (model.Transactions && model.Transactions.length > 0) {
            return (
                <div className="project-transactions-total-amounts">
                    {Object.entries(getTransactionsByCurrency(model.Transactions)).map(([key, value]) => (
                        <Money
                            key={key}
                            highlightCurrency
                            amounts={value.map((item) => item.TotalFee)}
                            currency={key}
                        />
                    ))}
                </div>
            );
        } else {
            return null;
        }
    };

    const EventTransactionsModelDetails = () => {
        const model = event.Models.find((item) => item.ModelID === modelID);
        if (!model || !model.Transactions) return null;
        //TODO: usare totali da statement cliente per avere anche agencyfee
        return model.Transactions.map((item) => (
            <div key={item.id} className="project-transactions-model">
                <TransactionTitleLine transaction={item} inline />
                <div className="project-transactions-total-amounts">
                    <Money highlightCurrency amount={item.TotalFee} currency={item.Currency} />
                </div>
            </div>
        ));
    };

    if (event.Models && event.Models.length > 0) {
        if (modelID) {
            return (
                <EventTransactionsWrapper>
                    <div className="project-transactions-header">
                        <h3>{saxonize(getContactName(modelID))} fees &amp; expenses</h3>
                        <EventTransactionsModel />
                    </div>
                    <div className="project-transaction-content">
                        {hastransactions ? (
                            <Collapse accordion ghost>
                                {hasmodeltransactions && (
                                    <Panel header={`${saxonize(getContactName(modelID))} transaction details`} key="1">
                                        <div>
                                            <EventTransactionsModelDetails />
                                        </div>
                                    </Panel>
                                )}
                                {event.Models.length > 1 && (
                                    <Panel header="All models transactions" key="2">
                                        <div>
                                            <EventTransactionsByModel />
                                        </div>
                                    </Panel>
                                )}
                            </Collapse>
                        ) : (
                            <p></p>
                        )}
                    </div>
                </EventTransactionsWrapper>
            );
        }
        return (
            <EventTransactionsWrapper>
                <div className="project-transactions-header">
                    <h3>expenses and refund (total)</h3>
                    <EventTransactionsTotalAmount />
                </div>
                <div className="project-transaction-content">
                    {hastransactions && (
                        <Collapse accordion ghost>
                            <Panel header="Transactions by model" key="1">
                                <div>
                                    <EventTransactionsByModel />
                                </div>
                            </Panel>
                        </Collapse>
                    )}
                </div>
            </EventTransactionsWrapper>
        );
    }

    return (
        <EventTransactionsWrapper>
            <div className="project-transactions-header">
                <h3>fees (total)</h3>
                <EventTransactionsExternalJob />
            </div>
            <div className="project-transaction-content">
                {event.Transactions && event.Transactions.length > 1 ? (
                    <Collapse accordion ghost>
                        <Panel header="Transactions details" key="1">
                            <div>
                                <EventTransactionsExternalJobDetails />
                            </div>
                        </Panel>
                    </Collapse>
                ) : (
                    <p></p>
                )}
            </div>
        </EventTransactionsWrapper>
    );
};

export default NonBookingEventTransactionsSummary;
